/**
 * External dependencies
 */
import { IconBlock } from '~cartzillagb/icons'
import { range } from '~cartzillagb/util'
import { i18n, disabledBlocks, srcUrl } from 'cartzillagb'

/**
 * Internal dependencies
 */
import save from './save'
import edit from './edit'
import DefaultImage  from  './images/img1.png'

/**
 * WordPress dependencies
 */
import { applyFilters } from '@wordpress/hooks'
import { __ } from '@wordpress/i18n'


export const schema = {
	className : {
		type: 'string',
	},
	enableContainer: {
		type: 'boolean',
		default: true,
	},
	enableGutter: {
		type: 'boolean',
		default: false,
	},
	enableheader: {
		type: 'boolean',
		default: true,
	},
	enableIcon: {
		type: 'boolean',
		default: true,
	},
	
	design: {
		type: 'string',
		default: 'style-1',
	},
	limit: {
		type: 'number',
	},
	lgColumns : {
		type: 'number',
	},
	smColumns : {
		type: 'number',
		default: 2,
	},
	mdColumns : {
		type: 'number',
	},
	xlColumns : {
		type: 'number',
		default: 3,
	},
	heading : {
		type: 'string',
	},
	background : {
		type: 'string',
	},
	backgroundColor : {
		type: 'string',
	},
	titlecolor : {
		type: 'string',
	},
	customtitlecolor : {
		type: 'string',
	},
	desccolor : {
		type: 'string',
	},
	customdesccolor : {
		type: 'string',
	},
	headingcolor : {
		type: 'string',
	},
	customheadingcolor : {
		type: 'string',
	},
	iconcolor : {
		type: 'string',
	},
}

const maxLimit = applyFilters( 'cartzillagb.icon-blocks.edit.inspector.max.limit', 12 )

{ range( 1, maxLimit + 1 ).forEach( i => {

	schema[ `title${ i }` ] = {
		type: 'string',
	}
	schema[ `desc${ i }` ] = {
		type: 'string',
	}
	schema[ `icon${ i }` ] = {
		type: 'string',
	}
	schema[ `mediaURL${ i }` ] = {
		type: 'string',
		default: `${ srcUrl }/${ DefaultImage }`
	}
} ) }



export const name = 'czgb/icon-blocks'

export const settings = {
	title: __( 'Icon Blocks', i18n ),
	icon: IconBlock,
	category: 'cartzillagb',
	description: __( 'Start building your website with dozens of ready-to-use icon blocks.', i18n  ),
	example: {},
	keywords: [
		__( 'icon-blocks', i18n ),
		__( 'CartzillaGb', i18n ),
	],
	attributes: schema,
	supports: {
		inserter: ! disabledBlocks.includes( name ), // Hide if disabled.
	},

	edit,
	save,

	// CartzillaGB modules.
	modules: {
		'advanced-responsive': true,
	},
}